import _styled from "styled-components";
const _excluded = ["style", "className", "name", "value", "onChange", "defaultValue", "variant", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useControlled } from '@adsk/alloy-react-helpers';
import { stylePropType } from '@adsk/alloy-react-theme';
import RadioGroupContext from './RadioGroupContext';
const RADIO_GROUP_VARIANTS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
/**
 * A helpful wrapper for using multiple radio buttons.
 */
const RadioGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      name,
      value,
      onChange,
      defaultValue,
      variant = RADIO_GROUP_VARIANTS.VERTICAL,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [currentValue, handleOnChange] = useControlled(defaultValue, value, onChange);
  const context = useMemo(() => ({
    name,
    value: currentValue,
    onChange: handleOnChange
  }), [currentValue, handleOnChange, name]);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    role: "radiogroup"
  }, props, {
    className: className,
    ref: ref,
    $_css: [{
      display: 'flex',
      flexDirection: variant === RADIO_GROUP_VARIANTS.VERTICAL ? 'column' : 'row'
    }, style]
  }), /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: context
  }, children));
});
RadioGroup.displayName = 'RadioGroup';
RadioGroup.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The name to propogate to the radio buttons */
  name: PropTypes.string,
  /** The value of the radio group (propagated as well to the radio buttons) */
  value: PropTypes.any,
  /** The initial value of the radio, this will be read only if `checked` is undefined */
  defaultValue: PropTypes.any,
  /** onChange handler for the radio input */
  onChange: PropTypes.func,
  /** The content of the radio group, should be `[RadioButton]` */
  children: PropTypes.any,
  /** style variant one of RadioGroup.DIRECTIONS */
  variant: PropTypes.oneOf(Object.values(RADIO_GROUP_VARIANTS))
};
export default Object.assign(RadioGroup, {
  VARIANTS: RADIO_GROUP_VARIANTS
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "RadioGroup___StyledDiv",
  componentId: "sc-qlhnfr-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=RadioGroup.js.map